import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import {
    ClientDomainModel,
    ClientDomainUpdateModel,
    ClientDomainInsertModel,
} from '../interfaces/client-domain-data';

@Injectable({
    providedIn: 'root',
})
export class ClientDomainService extends BehaviorSubject<any[]> {
    private serverUrl = 'https://' + window.location.host; // TODO Get url and version number from appsettings.
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/clientdomain/').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {
        super([]);
    }

    getDomains(): Observable<ClientDomainModel[]> {
        return this.http.get<ClientDomainModel[]>(this._url + 'GetClientDomains');
    }

    getEmailCount(domain: string): Observable<any> {
        const params = new HttpParams().set('domain', domain);
        return this.http.get<any>(this._url + 'GetEmailCount', {
            params: params,
        });
    }

    deleteDomain(domainKey: number): Observable<any> {
        return new Observable((subscriber) => {
            this.http.post<any>(this._url + 'DeleteClientDomain', domainKey).subscribe(
                () => {
                    subscriber.next(true);
                },
                (response) => {
                    subscriber.error(response);
                }
            );
        });
    }

    insertDomain(domain: ClientDomainModel): Observable<any> {
        let insertModel = this.convertToInsertModel(domain);
        let formattedModel: JSON = this.formatInsertModel(insertModel);
        return new Observable((subscriber) => {
            this.http.post<any>(this._url + 'InsertClientDomain', formattedModel).subscribe(
                () => {
                    subscriber.next(true);
                },
                (response) => {
                    subscriber.error(response);
                }
            );
        });
    }

    convertToInsertModel(model: ClientDomainModel): ClientDomainInsertModel {
        var insertModel: ClientDomainInsertModel = {
            domain: model.domain,
        };

        return insertModel;
    }

    formatInsertModel(insertModel: ClientDomainInsertModel): any {
        return {
            domain: insertModel.domain,
        };
    }

    updateDomain(domain: ClientDomainModel): Observable<any> {
        var updateModel = this.convertToUpdateModel(domain);
        let formattedModel: JSON = this.formatUpdateModel(updateModel);
        return new Observable((subscriber) => {
            this.http.post<any>(this._url + 'UpdateClientDomain', formattedModel).subscribe(
                () => {
                    subscriber.next(true);
                },
                (response) => {
                    subscriber.error(response);
                }
            );
        });
    }

    convertToUpdateModel(model: ClientDomainModel): ClientDomainUpdateModel {
        var updateModel: ClientDomainUpdateModel = {
            clientDomainKey: model.clientDomainKey,
            domain: model.domain,
        };

        return updateModel;
    }

    formatUpdateModel(updateModel: ClientDomainUpdateModel): any {
        return {
            clientDomainKey: updateModel.clientDomainKey,
            domain: updateModel.domain,
        };
    }
}
